import { NgModule }              from '@angular/core';
import { CommonModule }          from '@angular/common';
import { I18NextModule }         from 'angular-i18next';
import { PackDownloadComponent } from './components/pack-download/pack-download.component';



@NgModule({
  declarations: [
    PackDownloadComponent
  ],
  imports: [
    CommonModule,
    I18NextModule
  ]
})
export class DataPackModule { }
